<template>
    <div :class="pieCountClass">
        <span class="rating-pie__number">
            {{ rating || 'N/A' }}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            rating: { type: Number, default: undefined },
            type: { type: String, default: undefined },
            size: { type: String, default: 'large' },
        },

        computed: {
            percentage() {
                return this.rating ? (this.rating / 5) * 100 : 0
            },

            pieCountClass() {
                return {
                    'rating-pie': true,
                    [`rating-pie--size-${this.size}`]: this.size,
                }
            },
        },

        methods: {
            calculateChart(value) {
                const RADIUS = 46
                var CIRCUMFERENCE = 2 * Math.PI * RADIUS

                this.$refs.value.style.strokeDasharray = CIRCUMFERENCE
                this.$refs.value.style.strokeDashoffset = CIRCUMFERENCE * (1 - value / 100)
            },
        },

        mounted() {
            this.calculateChart(this.percentage)
        },
    }
</script>
